import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	originalTransitionStatusName: {
		id: 'portfolio-3-plan-issue-status.ui.original-transition-status-name',
		defaultMessage: 'Transition to',
		description: 'Default golabel status transition name',
	},
});
